import { DateRange } from './date';
export class Attachments {
  filename: string;
  url: string;
  code: string;
  referenceId: string;
  createdBy: number;
  createdDate: string;
}

export class AttachmentSearch {
    createdDate: DateRange = DateRange.empty();
    todayDate: DateRange = DateRange.today();
    filename = '';
    id = '';
    title = '';
    code = '';
    transactionId = '';
    type = '';
    comments='';
 }
